/**
 * Main Application JavaScript
 * This file imports all modules and initializes them
 */

// Import all modules
import { initPopup } from './popup.js';
import { initMenu } from './menu.js';
import { initHeader } from './header.js';
import { initTextRotator } from './text-rotator.js';
import { initHeroSlider } from './hero-slider.js';
import { initSmoothScroll } from './smooth-scroll.js';
import { initGenericSliders } from './generic-slider.js';
import { initServicesPopup } from './services-popup.js';
import { initContactForm } from './contact-form.js';
import { initProjetsSlider } from './projets-slider.js';
import { initSuccessStoriesSlider } from './success-stories-slider.js';
import { initCurtainScroll } from './curtain-scroll.js';
import { talentGrid } from './talents-grid.js';
import { initLogoAnimation } from './logo-animation.js';
import { initFilterSidebar } from './filter-sidebar.js';
import { initSafariVideoFix } from './safari-video-fix.js';
import { initClientNavigation } from './client-navigation.js';
import { initMediaBlocks } from './media-blocks.js';

// Initialize Safari video fix immediately (it has its own DOM ready checks)
initSafariVideoFix();

// Initialize all modules when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    
    // Initialize popup functionality
    initPopup();
    
    // Initialize navigation menu
    initMenu();
    
    // Initialize header scroll effects
    initHeader();
    
    // Initialize text rotation animation
    initTextRotator();
    
    // Initialize hero slider
    initHeroSlider();
    
    // Initialize smooth scrolling
    initSmoothScroll();
    
    // Initialize curtain scroll effect
    initCurtainScroll();
    
    // Initialize generic sliders (team, etc.)
    initGenericSliders();
    
    // Initialize services popup
    initServicesPopup();
    
    // Initialize contact form
    initContactForm();
    
    // Initialize projets slider
    initProjetsSlider();
    
    // Initialize success stories slider (home page)
    initSuccessStoriesSlider();
    
    
    // Initialize talents grid
    talentGrid();
    
    // Initialize logo animations
    initLogoAnimation();
    
    // Initialize filter sidebar
    initFilterSidebar();
    
    // Initialize client navigation
    initClientNavigation();

    // Initialize media block play/pause controls
    initMediaBlocks();

});